import { Accordion, AccordionItem } from '@sainsburys-tech/luna-react';
import * as React from 'react';
export default {
  Accordion,
  AccordionItem,
  React
};